export * from './lib/shared-dtos-protected-entities-common';
